export default function(timestamp)
{
	return timestamp && new Date(timestamp * 1000)
}